module.exports = __webpack_public_path__ + "img/selfiecardexample.9f10996a.svg";